module.exports = __webpack_public_path__ + "img/google.9a8282d0.png";